export var source = "fragment Product on Product {\n  id\n  name\n  brand\n  image\n  volume\n  unit\n  price\n  upchargePrice\n}";
export default source;